<template>
  <div>
    <b-overlay
      variant="white"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
      :show="loading"
    >

      <b-card>
        <b-form @submit.prevent="applySearch">
          <b-container fluid>
            <b-row class="mb-2">
              <b-col md="3">
                <label for="name">Search by name</label>
                <b-form-input
                  id="name"
                  v-model="queryParams.name"
                  placeholder="Business Name"
                />
              </b-col>
              <b-col md="3">
                <label for="email">Search by email</label>
                <b-form-input
                  id="email"
                  v-model="queryParams.email"
                  placeholder="Business Email"
                />
              </b-col>
              <b-col md="3">
                <label for="phoneNo">Search by Phone No.</label>
                <b-form-input
                  id="phoneNo"
                  v-model="queryParams.phoneNumber"
                  placeholder="Business phoneNumber"
                />
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="Search by Business Type"
                  label-for="business-type"
                >
                  <v-select
                    id="business-type"
                    v-model="queryParams.businessTypeLogicalId"
                    placeholder="Business Type"
                    label="logicalId"
                    :reduce="val => val.logicalId"
                    :options="businessTypes"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
              >
                <div class="mt-1 d-flex justify-content-between align-items-center">
                  <b-button
                    variant="primary"
                    type="submit"
                  >
                    Search
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="clearFilter"
                  >
                    Clear
                  </b-button>
                  <b-button
                    class="btn-icon rounded-circle"
                    variant="flat-primary"
                    type="submit"
                  >
                    <feather-icon
                      icon="RefreshCwIcon"
                    />
                  </b-button>
                </div>
              </b-col>
              <b-col
                md="9"
                class="mt-1 d-flex justify-content-end align-items-center"
              >
                <b-button
                  variant="primary"
                  to="/businesses/create"
                >
                  Create new business
                </b-button>

              </b-col>
            </b-row>
          </b-container>
        </b-form>
        <b-table
          hover
          striped
          :items="list"
          :fields="tableColumns"
          show-empty
          empty-text="Empty"
        >
          <template #cell(actions)="data">
            <b-button
              v-if="data.item.businessTypes && data.item.businessTypes.length"
              class="btn-icon rounded-circle"
              variant="flat-primary"
              :to="businessTypeRedirection(data.item.businessTypes[0].logicalId, data.item.id, data.item.externalId)"
            >
              <feather-icon
                size="20"
                icon="EyeIcon"
              />
            </b-button>
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          class="mt-1"
          :total="total"
          @input="fetchList"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BTable, BOverlay, BButton, BContainer, BRow, BCol, BFormInput, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import BasePagination from '@/UI/BasePagination.vue'
import businessStore from '../store'
import useList from '../hooks/useList'

export default {
  components: {
    BCard,
    BButton,
    BTable,
    BOverlay,
    BasePagination,
    BContainer,
    BRow,
    BCol,
    BFormInput,
    BForm,
    vSelect,
    BFormGroup,
    // TransitionBusinessModal,
  },
  setup(props, ctx) {
    useRegisterStoreModule('business', businessStore)

    return {
      ...useList(props, ctx),
    }
  },
}
</script>

  <style scoped>
  </style>
